import type { AffiliateCommissionHistoryItem } from '../services/affiliateService'

export function getCommissionHistoryDayKey(item: AffiliateCommissionHistoryItem): string {
  if (item.createdAt) {
    const parsed = new Date(item.createdAt)
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' })
    }
  }
  if (item.date) return item.date
  return '–'
}

export function aggregateCommissionHistoryByDay(
  items: AffiliateCommissionHistoryItem[],
): AffiliateCommissionHistoryItem[] {
  const grouped = new Map<string, { betAmount: number; commission: number; sortKey: number }>()

  for (const item of items) {
    const dayKey = getCommissionHistoryDayKey(item)
    const sortKey = item.createdAt ? new Date(item.createdAt).getTime() : 0
    const existing = grouped.get(dayKey)

    if (existing) {
      existing.betAmount += Number(item.betAmount || 0)
      existing.commission += Number(item.commission || 0)
      existing.sortKey = Math.max(existing.sortKey, sortKey)
      continue
    }

    grouped.set(dayKey, {
      betAmount: Number(item.betAmount || 0),
      commission: Number(item.commission || 0),
      sortKey,
    })
  }

  return Array.from(grouped.entries())
    .sort((left, right) => right[1].sortKey - left[1].sortKey)
    .map(([date, totals]) => ({
      date,
      betAmount: totals.betAmount,
      commission: totals.commission,
    }))
}

export function formatCommissionHistoryDateTime(item: AffiliateCommissionHistoryItem): string {
  if (item.createdAt) {
    const parsed = new Date(item.createdAt)
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleString('th-TH', { dateStyle: 'medium', timeStyle: 'short' })
    }
  }
  if (item.date) return item.date
  return '–'
}

export function formatCommissionMemberLabel(
  item: AffiliateCommissionHistoryItem,
  maskMember: (raw: string) => string,
): string {
  const label = String(item.referredDisplayName || item.referredUsername || '').trim()
  return maskMember(label || 'สมาชิก')
}
